import React, { useEffect, useState } from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography, Divider, Icon } from '@mui/material';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import AptaTable from 'examples/AptaTable';
import axios from 'axios';
import { URL } from 'constants/constant';
import * as XLSX from 'xlsx';

function HotelBooking() {
    const [hotelBookings, setHotelBookings] = useState([]);
    const [open, setOpen] = useState(false);
    const [selectedBooking, setSelectedBooking] = useState(null);

    useEffect(() => {
        fetchHotelBookings();
    }, []);

    async function fetchHotelBookings() {
        try {
            const response = await axios.get(`${URL}/api/admin/hotel`);
            if (response.status === 200) {
                setHotelBookings(response.data?.data?.reverse() || []);
            } else {
                console.error('Unexpected response code:', response.status);
            }
        } catch (error) {
            console.error('Error fetching hotel bookings:', error);
        }
    }

    const handleOpen = (booking) => {
        setSelectedBooking(booking);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setSelectedBooking(null);
    };

    const handleDownloadExcel = () => {
        const excelData = hotelBookings.map((booking) => ({
            Name: booking.name || 'N/A',
            Mobile: booking.mobile || 'N/A',
            Email: booking.email || 'N/A',
            Occupancy: booking.occupancy || 'N/A',
            State: booking.state || 'N/A',
            City: booking.city || 'N/A',
            'Check-in Date': booking.checkin ? new Date(booking.checkin).toLocaleDateString() : 'N/A',
            'Check-out Date': booking.checkout ? new Date(booking.checkout).toLocaleDateString() : 'N/A',
            'Hotel Name': booking.hotelName || 'N/A',
        }));

        const worksheet = XLSX.utils.json_to_sheet(excelData);

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Hotel Bookings');

        XLSX.writeFile(workbook, `Hotel_Bookings_${new Date().toISOString().slice(0, 10)}.xlsx`);
    };

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <Box sx={{ mb: 2, display: 'flex', justifyContent: 'flex-end' }}>
                <Button
                    variant="contained"
                    color="success"
                    onClick={handleDownloadExcel}
                    startIcon={<Icon>download</Icon>}
                    style={{ color: 'black', backgroundColor: '#A4FFAF' }}
                >
                    Download Excel
                </Button>
            </Box>
            <AptaTable
                columns={['Name', 'Email', 'Mobile', 'Actions']}
                rows={hotelBookings.map((booking) => ({
                    Name: booking?.name || 'N/A',
                    Email: booking?.email || 'N/A',
                    Mobile: booking?.mobile || 'N/A',
                    Actions: (
                        <Button
                            variant="contained"
                            onClick={() => handleOpen(booking)}
                            style={{ color: 'white' }}
                        >
                            <Icon>visibility</Icon>
                        </Button>
                    ),
                }))}
            />

            {/* Modal for showing full hotel booking details */}
            <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
                <DialogTitle>Hotel Booking Details</DialogTitle>
                <DialogContent>
                    {selectedBooking && (
                        <Box>
                            <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1 }}>
                                Contact Information
                            </Typography>
                            <Divider sx={{ mb: 1 }} />
                            <Typography><strong>Name:</strong> {selectedBooking.name}</Typography>
                            <Typography><strong>Email:</strong> {selectedBooking.email}</Typography>
                            <Typography><strong>Mobile:</strong> {selectedBooking.mobile}</Typography>

                            <Typography variant="h6" sx={{ fontWeight: 'bold', mt: 2, mb: 1 }}>
                                Booking Details
                            </Typography>
                            <Divider sx={{ mb: 1 }} />
                            <Typography><strong>Hotel:</strong> {selectedBooking.hotelName || 'N/A'}</Typography>
                            <Typography><strong>Check-in Date:</strong> {selectedBooking.checkin?.slice(0, 10) || 'N/A'}</Typography>
                            <Typography><strong>Check-out Date:</strong> {selectedBooking.checkout?.slice(0, 10) || 'N/A'}</Typography>
                            <Typography><strong>Occupancy:</strong> {selectedBooking.occupancy}</Typography>
                            <Typography><strong>State:</strong> {selectedBooking.state}</Typography>
                            <Typography><strong>City:</strong> {selectedBooking.city}</Typography>
                        </Box>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="secondary">Close</Button>
                </DialogActions>
            </Dialog>
        </DashboardLayout>
    );
}

export default HotelBooking;